const { isEmpty } = require('lodash');
const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class FulfilmentSelectorDeliveryAddressController {
    constructor($q, settings, addressService, analyticsService, fulfilmentSelectorService, moveFocus) {
        this.$q = $q;
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.moveFocus = moveFocus;
        this.isEmpty = isEmpty;
    }

    $onInit() {
        this.autocompleteText = this.fulfilmentSelectorService.getFullDeliveryAddress(this.selectedAddress);
        this.hasSearched = !!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch;
        this.searchModeSavedAddresses = 'SAVED_ADDRESSES';
        this.searchModeAmasAddress = 'AMAS_ADDRESSES';
        this.shouldShowSavedAddresses = false;
        this.savedAddressesPerPage = this.settings.fulfilmentSelector.pickupStoresPerPage;
        this.numberOfSavedAddressesToShow = this.savedAddressesPerPage;
        this.shouldShowDismissButton = false;

        this.screenName = 'FulfilmentSelection';
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Fulfilment type toggle')
            .withValue('Delivery')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_view')
            .build();

        this.analyticsService.push(event);

        this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
    }

    manageVisibilityOfDismissButton(value) {
        this.shouldShowDismissButton = value;
    }

    hasSavedAddresses() {
        return this.savedAddresses && this.savedAddresses.length > 0;
    }

    hasMoreSavedAddresses() {
        return this.hasSavedAddresses() && this.numberOfSavedAddressesToShow < this.savedAddresses.length;
    }

    viewMoreSavedAddresses() {
        if (this.hasMoreSavedAddresses()) {
            this.numberOfSavedAddressesToShow += this.savedAddressesPerPage;
        }
    }

    onAddressSelected(address) {
        if (!this.selectedAddress || this.selectedAddress.AddressId !== address.AddressId) {
            const event = new TealiumEventBuilder()
                .withScreenName(this.screenName)
                .withLabel('AddressChange')
                .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
                .withEventName('modal_interaction')
                .build();

            this.analyticsService.push(event);
        }
        if (!isEmpty(address)) {
            this.autocompleteText = this.fulfilmentSelectorService.getFullDeliveryAddress(address);
            this.shouldShowSavedAddresses = !this.shouldShowSavedAddresses;
            this.hasSearched = !!this.autocompleteText;
            this.onSavedAddressSelected({ addr: address });
            this.manageVisibilityOfDismissButton(false);
        }
    }

    clearSearch(input) {
        if (input) {
            this.autocompleteText = null;
            this.selectedAddress = null;
            this.hasSearched = false;
            this.switchSavedAddressSearchMode();
            this.moveFocus(`#address-${this.inputId}`);
        }
        if (!input && this.shouldShowSavedAddresses) {
            this.switchAmasSearchMode();
            this.manageVisibilityOfDismissButton(false);
        }
    }

    switchAmasSearchMode() {
        this.activeSearchMode = this.searchModeAmasAddress;
        this.shouldShowSavedAddresses = false;
    }

    switchSavedAddressSearchMode() {
        this.activeSearchMode = this.searchModeSavedAddresses;
        this.shouldShowSavedAddresses = true;
    }

    getItemText(item) {
        return item.Text;
    }

    saveSearchedAddress(address) {
        if (!isEmpty(address)) {
            this.autocompleteText = address.Text;
            this.shouldShowSavedAddresses = false;
            this.onSaveAutoAddress({ address });
            this.manageVisibilityOfDismissButton(false);
        }
    }

    openManualAddressForm() {
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Button/link click')
            .withValue('Add manually')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .build();
        this.analyticsService.push(event);

        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.manualAddress;
    }

    showSavedAddresses() {
        this.shouldShowSavedAddresses = this.hasSavedAddresses();
        this.activeSearchMode = this.shouldShowSavedAddresses ? this.searchModeSavedAddresses : this.searchModeAmasAddress;
        this.hasSearched = !!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch;
    }

    addressOnType() {
        if (!!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch) {
            this.switchAmasSearchMode();
            this.addressService._clearAutoAddresses();
            return this.addressService.search(this.autocompleteText).then(response => (response ? this.addressService.autoAddresses : []));
        }
        return this.$q.defer().promise;
    }

    $onDestroy() {
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }
}

FulfilmentSelectorDeliveryAddressController.$inject = ['$q', 'Settings', 'AddressService', 'AnalyticsService', 'FulfilmentSelectorService', 'MoveFocus'];

const fulfilmentSelectorDeliveryAddressComponentDefinition = {
    bindings: {
        inputId: '@',
        savedAddresses: '<?',
        onSaveAutoAddress: '&?',
        onSavedAddressSelected: '&?',
        selectedAddress: '<?',
    },
    controller: FulfilmentSelectorDeliveryAddressController,
    template: require('./fulfilment-selector-delivery-address.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDeliveryAddressController,
    fulfilmentSelectorDeliveryAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-delivery-address.component.js